import request from "@/utils/request";

const HTTP_PREFIX = '/wayline/api/v1'

/**
 * 获取静态资源（JSON）等
 * @param {*} fetchStr
 * @returns
 */
export async function getStaticData(fetchStr: any) {
  const baseURL = import.meta.env.BASE_URL;
  const res = request({
    baseURL,
    url: fetchStr,
    method: "get",
  });
  return res;
}


//船标获取
export const getShipInfoMarkList = async (body: any): Promise<any> => {
  const url = `/uav/ais/list`
  const result = await request.post(url, body)
  return result.data
}

//航标获取
export const getnavigationMarkList = async (body: any): Promise<any> => {
  const url = `/uav/navigationMark/getNavigationMarkList` 
  const result = await request.post(url, body)
  return result.data
}

// 获取附近设备列表
export const getNearbyList = async function (data:object): Promise<any> {
  const url = `/uav/wayLineJob/tempList`
  const result = await request.post(url, data)
  return result.data
}
// 一键出警
export const clickAlert = async function (data:object): Promise<any> {
  const url = `/uav/wayLineJob/tempJob`
  const result = await request.post(url, data)
  return result.data
}
